<template>
    <bottom-dialog v-model="showWatchDialog" scrollable max-width="500px" :dialog="!$vuetify.breakpoint.mobile" v-if="showWatchDialog" @click:outside="closeDialog">
        <v-card class="zoezi-bottom-sheet" tile elevation="0">
            <v-card-title class="headline align-start flex-column pa-2 primary primarytext--text">
                <div class="font-weight-bold fill-width">
                    <span v-text="entity.name" />
                    <v-btn icon @click="closeDialog" class="float-right"><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                </div>
            </v-card-title>

            <v-card-text :class="{'px-2': $vuetify.breakpoint.mobile }" class="z-no-x-scroll">
                <template>
                    <div class="mt-2 mb-2">
                        <v-expansion-panels>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row no-gutters align="center">
                                        <v-col cols="auto">
                                            <v-icon>mdi-information</v-icon>
                                        </v-col>
                                        <v-col class="ml-2">
                                            {{ $translate("How does watching work?") }}
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    {{ watchInfoText }}
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                </template>
                <template v-if="infoComponent">
                    <component :is="infoComponent" v-bind="infoComponentProps" class="mb-2" />
                </template>
                <template v-if="$store.state.isLoggedIn">
                    <div class="mt-2 mb-2">
                        <v-expansion-panels>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row no-gutters align="center">
                                        <v-col cols="auto">
                                            <v-icon>mdi-account-question</v-icon>
                                        </v-col>
                                        <v-col class="ml-2">
                                            <div>{{ $translate("How do you want to be notified?") }}</div>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    {{ $translate("You can fill in both email address and phone number, but mark the method you prefer to use by ticking the box next to it. The contact method used is also depend on settings set by staff for watching.") }}
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                    <v-form v-model="watch.formValid">
                        <form-field :field="watch.firstname" star v-model="watch.firstname.value" />
                        <form-field :field="watch.lastname" star v-model="watch.lastname.value" />

                        <template v-if="hasSms">
                            <div class="d-flex" v-if="showEmail">
                                <v-simple-checkbox v-model="watch.sendMail" color="primary" :ripple="false" />
                                <form-field class="ml-2" :field="watch.mail" star v-model="watch.mail.value" />
                            </div>
                            <div class="d-flex" v-if="showSms">
                                <v-simple-checkbox v-model="watch.sendSms" color="primary" :ripple="false" />
                                <form-field class="ml-2" :field="watch.phone" star v-model="watch.phone.value" />
                            </div>
                        </template>
                        <form-field v-else :field="watch.mail" star v-model="watch.mail.value" />
                        <v-alert v-if="formChanged" text dense border="left"  icon="mdi-alert-circle-outline" type="info">{{ $translate("Your account will be updated with the changes made.") }}</v-alert>
                    </v-form>
                </template>
                <identification v-else
                                :title="notLoggedInTitle"
                />

            </v-card-text>
            <v-card-actions>
                <template v-if="$store.state.isLoggedIn">
                    <template v-if="isWatching">
                        <v-btn style="width: 50%" outlined color="error" class="zoezi-button-thin" @click="stopWatching">
                            {{ $translate("Cancel watching")}}
                        </v-btn>
                        <v-btn style="width: 50%" color="primary" class="zoezi-button-thin"  @click="startWatching" :disabled="!watch.formValid" :loading="watch.loading">
                            {{ $translate("Save") }}
                        </v-btn>
                    </template>
                    <template v-else>
                        <v-btn style="width: 50%" outlined color="primary" class="zoezi-button-thin" @click="closeDialog">
                            {{ $translate("Cancel") }}
                        </v-btn>
                        <v-btn style="width: 50%" color="primary" class="zoezi-button-thin"  @click="startWatching" :disabled="!watch.formValid" :loading="watch.loading">
                            {{ $translate("Watch")  }}
                        </v-btn>
                    </template>
                </template>
                <v-btn v-else block outlined color="primary" class="zoezi-button-thin"  @click="closeDialog">
                    <div class="ma-1 fill-width text-center">
                        {{ $translate("Cancel") }}
                    </div>
                </v-btn>
            </v-card-actions>
        </v-card>
    </bottom-dialog>
</template>

<script>
import BottomDialog from '../components/BottomDialog.vue';
import FormField from '../components/FormField.vue';

export default {
    name: 'zoezi-watch-dialog',

    components: {
        BottomDialog,
        FormField
    },

    props: {
        value: {
            type: Boolean
        },
        entity: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        infoComponent: {
            type: Object,
            required: false
        },
        infoComponentProps: {
            type: Object,
            required: false
        },
        showEmail: {
            type: Boolean,
            default: true
        },
        showSms: {
            type: Boolean,
            default: true
        },
    },

    data() {
        return {
            showWatchDialog: false,
            watch: {
                firstname: {type: 'text', title: 'First name', required: true, readonly: false, value: ''},
                lastname: {type: 'text', title: 'Last name', required: true, readonly: false, value: ''},
                phone: {type: 'phone', title: 'Mobile phone number', icon: 'mdi-cellphone-iphone', required: true, readonly: false, value: ''},
                mail: {type: 'email', title: 'E-Mail', required: true, icon: 'mdi-email', readonly: false, value: ''},
                sendMail: true,
                sendSms: true,
                loading: false,
                formValid: false,
            },
            formChanged: false,
            initialState: null,
        }
    },

    mounted() {
        this.initialState = JSON.parse(JSON.stringify(this.watch));
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.updateWatch();
                this.showWatchDialog = value;
            }
        },
        '$store.state.isLoggedIn': {
            immediate: true,
            handler(isLoggedIn) {
                if (isLoggedIn && this.$store.state.user) {
                    this.watch.firstname.value = this.$store.state.user.firstname;
                    this.watch.lastname.value = this.$store.state.user.lastname;
                    this.watch.mail.value = this.$store.state.user.mail;
                    this.watch.phone.value = this.$store.state.user.phone;
                    this.watch.sendMail = !!this.$store.state.user.mail;
                    this.watch.sendSms = !!this.$store.state.user.phone;
                }
            },
        },
        'watch.sendMail'(sendMail) {
            this.watch.mail.required = sendMail;
            this.watch.mail.readonly = !sendMail;
        },
        'watch.sendSms'(sendSms) {
            this.watch.phone.required = sendSms;
            this.watch.phone.readonly = !sendSms;
        },
        watch: {
            handler() {
                this.formChanged = !this.isEqual(this.watch, this.initialState);
            },
            deep: true
        }
    },

    methods: {
        isEqual(obj1, obj2) {
            return JSON.stringify(obj1) === JSON.stringify(obj2);
        },
        startWatching() {
            this.watch.loading = true;
            this.updateMemberInformationIfNeeded(() => {
                let data = {
                    [this.typeIdKey]: this.entity.id,
                    mail: this.watch.sendMail,
                    sms: this.hasSms && this.watch.sendSms
                };
                this.$api.post('/api/memberapi/watch/add', null, data).then((response) => {
                    response.json().then(data => {
                        this.watch.loading = false;
                        if (response.ok) {
                            this.closeDialog();
                        } else {
                            let text = this.$translate(data.message);
                            this.$store.commit('showSnackBar', {text});
                        }
                    })
                } )
            });
        },
        stopWatching() {
            this.$api.post('/api/memberapi/watch/remove', null, {[this.typeIdKey]: this.entity.id});
            this.closeDialog();
        },
        updateWatch() {
            let user = this.$store.state.user;
            this.watch.firstname.value = user?.firstname;
            this.watch.lastname.value = user?.lastname;
            this.watch.mail.value = user?.mail;
            this.watch.phone.value = user?.phone;

            if (this.watchInfo) {
                this.watch.sendMail = this.watchInfo.mail;
                this.watch.sendSms = this.watchInfo.sms;
            } else {
                this.watch.sendMail = !!this.watch.mail.value;
                this.watch.sendSms = !!this.watch.phone.value;
            }
        },
        updateMemberInformationIfNeeded(cb) {
            let user = this.$store.state.user;
            let data = {};
            let props = ['firstname', 'lastname', 'mail'];
            if (this.hasSms) {
                props.push('phone');
            }
            let needUpdate = false;
            props.forEach(prop => {
                if (this.watch[prop].value != user[prop]) {
                    data[prop] = this.watch[prop].value;
                    needUpdate = true;
                }
            })

            if (needUpdate) {
                this.$api.post('/api/memberapi/change', data).then(() => {
                    this.formChanged = false;
                    cb();
                });
            } else {
                cb();
            }
        },
        closeDialog() {
            this.showWatchDialog = false;
            this.$emit('close');
        },
    },

    computed: {
        hasSms() {
            return this.$store.state.settings?.sms;
        },
        isWatching() {
            const watches = this.entity && this.$store.state.bookings?.[`${this.type}watches`];
            return watches?.some(w => w[this.typeIdKey] == this.entity.id && w.user_id == this.$store.state.user?.id);
        },
        notLoggedInTitle() {
            return this.$translate("The activity is fully booked, but you can watch for available spots by identifying yourself below. If you don't have an account, one will be created automatically.")
        },
        typeIdKey() {
            return `${this.type}_id`;
        },
        watchInfoText() {
            switch (this.type) {
                case 'course':
                    return this.$translate("COURSE_WATCH_INFO");
                case 'gameclass':
                    return this.$translate("TEAMSPORT_WATCH_INFO");
                default:
                    return '';
            }
        }
    },
}

</script>


